import React, { useEffect, useState } from "react";

import { Outlet, useLocation } from "react-router-dom";

import Header from "../components/header/Header";
import Footer from "../components/Footer/Footer";
import ScrollGames from "../components/ScrollGames/ScrollGames";
import SideMenu from "../components/SideMenu/SideMenu";
import OpenBets from "../components/OpenBets/OpenBets";

import "../App.css";

function MainLayout() {
  const location = useLocation();

  const [showMenu, setShowMenu] = useState(false);

  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 991);

  const [eventType, setEventType] = useState(undefined);

  /*
   * Route ko normalize karega:
   * /account-statement/
   * /ACCOUNT-STATEMENT
   * dono correctly work karenge.
   */
  const currentPath =
    location.pathname.replace(/\/+$/, "").toLowerCase() || "/";

  const isAccountStatementPage =
    currentPath === "/account-statement" || currentPath === "/accountstatement";

  const isOpenBetsPage = currentPath === "/openbets";

  const isFundsPage = currentPath === "/deposit" || currentPath === "/withdraw" || currentPath === "/add-withdraw-method";

  /*
   * ScrollGames/sports navigation sirf un pages
   * par dikhani hai jahan required hai.
   */
  const showScrollGames =
    !isAccountStatementPage && !isOpenBetsPage && !isFundsPage;

  /*
   * Right-side Open Bets Account Statement
   * aur Open Bets page par nahi dikhega.
   */
  const showRightOpenBets =
    !isAccountStatementPage && !isOpenBetsPage && !isFundsPage;

  const handleToggleMenu = () => {
    setShowMenu((previousValue) => !previousValue);
  };

  const openSideMenu = () => {
    setShowMenu(true);
  };

  const closeSideMenu = () => {
    setShowMenu(false);
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 991;

      setIsMobile(mobile);

      if (!mobile) {
        setShowMenu(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  /*
   * Route change hote hi mobile drawer close hoga.
   */
  useEffect(() => {
    setShowMenu(false);
  }, [currentPath]);

  /*
   * Mobile SideMenu open hone par background
   * scrolling temporarily stop hogi.
   */
  useEffect(() => {
    if (!isMobile) {
      document.body.style.overflow = "";
      return;
    }

    document.body.style.overflow = showMenu ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobile, showMenu]);

  return (
    <div
      className={[
        "main-layout-shell",
        isAccountStatementPage ? "main-layout-account-statement" : "",
        isFundsPage ? "main-layout-funds-page" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <Header
        showMenu={showMenu}
        openSideMenu={openSideMenu}
        closeSideMenu={closeSideMenu}
        handleToggleMenu={handleToggleMenu}
        isMobile={isMobile}
        setEventType={setEventType}
      />

      {/* Account Statement par ye row nahi aayegi */}
      {showScrollGames && (
        <div className="main-layout-sports-nav">
          <ScrollGames
            setEventType={setEventType}
            eventType={eventType}
            isMobile={isMobile}
          />
        </div>
      )}

      <div className="main-layout-body">
        {isMobile ? (
          <>
            <main className="main-layout-mobile-content">
              <Outlet />
            </main>

            {showMenu && (
              <>
                <button
                  type="button"
                  className="sidemenu-overlay"
                  onClick={closeSideMenu}
                  aria-label="Close side menu"
                />

                <aside
                  className="sidemenu-mobile open"
                  onClick={(event) => event.stopPropagation()}
                >
                  <SideMenu
                    handleToggleMenu={closeSideMenu}
                    closeSideMenu={closeSideMenu}
                    isMobile
                    setEventType={setEventType}
                  />
                </aside>
              </>
            )}
          </>
        ) : (
          <div
            className={[
              "main-layout-desktop-grid",
              isAccountStatementPage ? "account-statement-grid" : "",
              isOpenBetsPage ? "open-bets-grid" : "",
              isFundsPage ? "funds-page-grid" : "",
            ]
              .filter(Boolean)
              .join(" ")}
          >
            <aside className="main-layout-left-sidebar">
              <SideMenu isMobile={false} setEventType={setEventType} />
            </aside>

            <main className="main-layout-center-content">
              <Outlet />
            </main>

            {showRightOpenBets && (
              <aside className="main-layout-right-sidebar">
                <OpenBets />
              </aside>
            )}
          </div>
        )}
      </div>

      {/* Account Statement ke bottom mein Footer */}
      {isAccountStatementPage && <Footer />}
    </div>
  );
}

export default MainLayout;
